<template>
    <div ref="panel" v-on="$listeners">
        <slot />
    </div>
</template>

<script>
import ResizeObserver from 'resize-observer-polyfill';
import _ from 'lodash';

export default {
    name: 'SyResizePanel',
    data() {
        return {
            observer: null
        };
    },
    /**
     * 组件渲染后监听panel尺寸变化
     */
    mounted() {
        // 创建ResizeObserver实例
        this.observer = new ResizeObserver(
            _.throttle(entries => {
                // 因为只观察了一个dom节点,所以只会有一个entry
                const contentRect = entries[0].contentRect;
                const rect = {
                    x: contentRect.x,
                    y: contentRect.y,
                    width: contentRect.width,
                    height: contentRect.height
                };
                this.$emit('resize', rect);
            })
        );
        this.observer.observe(this.$refs.panel);
    },
    /**
     * 组件销毁前取消监听panel尺寸变化
     */
    beforeDestroy() {
        if (!this.observer) {
            return;
        }

        this.observer.unobserve(this.$refs.panel);
        this.observer = null;
    }
};
</script>
